import React, { useState } from "react"
import styles from './BaseList.module.css'
import View from "./View"
import Correct from "./Correct"
const BaseList = () => {
    const [selected, setSelected] = useState('correct')
    const [isBaseListShown, setIsBaseListShown] = useState(false);
    
    return (
        <div className={styles['BaseList-main-div']}>
           {selected === 'view' ? <View /> : selected === 'correct' ? <Correct /> : ''  }
        
            <div className={styles['BaseList-body-div']}>
            </div>
            
        </div>
    )
}

export default BaseList